import React from 'react'
import { useSelector } from 'react-redux'
import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Paper,
} from '../../../components/mui/Core/index'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import ItemDetailsCard from '../components/ItemDetailsCard/item-details-card'
import useBrowserTabTitles from '../../../hooks/browserTabTitles/browser-tab-titles'
import PageTitle from '../../../components/PageTitle/page-title'
import Constants from '../../../constants/en.json'
import DmsOrderAllocationsTable from './components/DmsOrderAllocationsTable/dms-order-allocations-table'
import WmsOrderAllocationsTable from './components/WmsOrderAllocationsTable/wms-order-allocations-table'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

function OrderAllocations() {
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)
  const isFetchingOrderAllocations = useSelector(
    (state) => state.orderAllocations.isFetchingOrderAllocations,
  )
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const dmsUser = selectedClient?.dmsFlag || authenticatedUser?.dms
  const pageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.orderAllocations.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} ${Constants.orderAllocations.ORDER_ALLOCATIONS}`
    : `${Constants.orderAllocations.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} ${Constants.orderAllocations.ORDER_ALLOCATIONS}`
  const browserTabTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.orderAllocations.ORDER_ALLOCATIONS_TITLE} ${selectedInventoryItem?.itemNumber}`
    : `${Constants.orderAllocations.ORDER_ALLOCATIONS_TITLE} ${selectedInventoryItem?.itemNumber}`
  useBrowserTabTitles(browserTabTitle)

  return (
    <Box data-testid='orderAllocations' sx={{ flexGrow: 1 }}>
      <GenericNav selected='Inventory' user='authenticated' />
      <Backdrop open={isFetchingOrderAllocations}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <PageTitle title={pageTitle} />
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ py: 5 }}>
            <ItemDetailsCard />
            {dmsUser === 'Y' ? <DmsOrderAllocationsTable /> : <WmsOrderAllocationsTable />}
          </Grid>
        </Grid>
        <Paper sx={{ width: '100%', mb: 2 }} />
      </Container>
    </Box>
  )
}

export default OrderAllocations
